import React, { useEffect } from 'react';

// Presents report content (a ReportShell) as a centered, scrollable overlay
// above the current screen instead of inserting it inline into the page —
// per pat-architecture-reports-ui-standard.md, a report must not push the
// underlying list/table out of place or grow the page around it.
//
// `report-overlay`/`report-overlay-inner` classes exist for App.css's
// print media query to neutralize this backdrop's fixed positioning and
// overflow, so a report longer than one page can flow across multiple.
// One opened from a FilterDrawer goes among the drawer's children (see
// FilterDrawer.js).
function ReportOverlay({ onClose, children }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div
      className="report-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.45)',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: '32px 16px',
        overflowY: 'auto',
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="report-overlay-inner" style={{ width: '100%', maxWidth: 900 }}>
        {children}
      </div>
    </div>
  );
}

export default ReportOverlay;
